$(function() {
  $(document).on('click', '.cottage-box .arrows button', function(e){
    e.preventDefault();
  });

  $(document).on('click', '.cottage-box .favBtn', function(e){
    e.preventDefault();
  });

  if ($(".thumbnails").length > 0) {
    initThumbnails();
  }
});

function initThumbnails() {
  $(".thumbnails").each(function() {
    var that = $(this);
    var nav = that.parent().find(".arrows");
    that.owlCarousel({
      loop:false,
      nav:true,
      dots:true,
      dotsEach: 4,
      items:1,
      navContainer:nav
    });
  });
}